import {supabase} from "../supabase_client"

const VITE_SUPABASE_PROJECT_URL = import.meta.env.VITE_SUPABASE_PROJECT_URL;

export const updateHistoryOnSupabase = async (playlist, userId) => {
    const { data, error } = await supabase.from("playlist_history").insert([
      {
        user_id: userId,
        playlist_name: playlist.name,
        playlist_songs: playlist.tracks.map(t => ({
          title: t.title,
          artist: t.artist || "Unknown"
        })),
        playlist_duration: playlist.duration,
        source_platform:playlist.sourcePlatform,
        destination_platform: playlist.destinationPlatform
      }
    ]);
    if (error) {
      console.error("Error inserting data:", error);
    } else {
      console.log("Inserted data:", data);
    }
  };

export const getHistoryFromSupabase = async (userId) => {
  const { data, error } = await supabase
    .from("playlist_history")
    .select("*")
    .eq('user_id', userId)
    .order("created_at", { ascending: false });
  if (error) {
    console.error("Error fetching history:", error);
    return [];
  }
  return data;
};

export const signUpWithEmail = async (email, password, name) => {
  const { data, error } = await supabase.auth.signUp({
    email,
    password,
    options: {
      data: { full_name: name }
    }
  });
  return { data, error };
};

export const signInWithEmail = async (email, password) => {
  const { data, error } = await supabase.auth.signInWithPassword({ email, password });
  return { data, error };
};

export const signOut = async () => {
  await supabase.auth.signOut();
};

// Profile management functions
export const updateUserProfile = async (updates) => {
  const { data, error } = await supabase.auth.updateUser({
    data: updates
  });
  return { data, error };
};

export const updateUserEmail = async (email) => {
  const { data, error } = await supabase.auth.updateUser({
    email: email
  });
  return { data, error };
};

export const updateUserPassword = async (password) => {
  const { data, error } = await supabase.auth.updateUser({
    password: password
  });
  return { data, error };
};

export const getUserProfile = async () => {
  const { data: { user }, error } = await supabase.auth.getUser();
  return { user, error };
};

export const deleteAccount = async () => {
  try {
    const { data: { session }, error: sessionError } = await supabase.auth.getSession();
    if (sessionError || !session) throw new Error("Unable to get session");

    const accessToken = session.access_token;

    const res = await fetch(`${VITE_SUPABASE_PROJECT_URL}/auth/v1/user`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        apikey: import.meta.env.VITE_SUPABASE_ANON_KEY,
      },
    });

    if (!res.ok) {
      const err = await res.json();
      throw new Error(err.message || "Failed to delete account");
    }

    await supabase.auth.signOut();
    return { success: true };
  } catch (error) {
    console.error("Error deleting account:", error.message);
    return { success: false, error: error.message };
  }
};



// export const deleteUserAccount = async () => {
//   try {
//     // Get current user and session
//     const { data: { user } } = await supabase.auth.getUser();
//     const { data: { session } } = await supabase.auth.getSession();
    
//     if (!user || !session) {
//       throw new Error('No authenticated user found');
//     }

//     // Call the serverless function to delete the account
//     const response = await fetch('/api/delete-account', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify({
//         userId: user.id,
//         userToken: session.access_token
//       })
//     });

//     const result = await response.json();

//     if (!response.ok) {
//       throw new Error(result.error || 'Failed to delete account');
//     }

//     // Sign out the user after successful deletion
//     await supabase.auth.signOut();
    
//     return { data: result, error: null };
//   } catch (error) {
//     console.error('Error deleting account:', error);
//     return { data: null, error: error.message };
//   }
// };